<section>
  <ng-container *ngIf="!!variable?.summaryStatistics?.sets?.length">
    <h3 mtnaOverlineIconHeading color="primary" i18n>Summary Statistics</h3>
    <div #populatedAndMissingChart class="rds-variable-stats--populated-and-missing-chart"></div>
    <rds-c-variable-distribution
      *ngIf="_showDistribution"
      [statSet]="$any(variable).summaryStatistics.sets[0]"
    ></rds-c-variable-distribution>
  </ng-container>

  <ng-container *ngIf="!!variable?.frequencies?.sets?.length && (loadingFrequencyChart || frequencyChartData)">
    <h3 mtnaOverlineIconHeading color="primary" i18n>Frequencies</h3>
    <mat-spinner
      *ngIf="loadingFrequencyChart"
      aria-label="Loading Frequencies"
      class="rds-variable-stats--frequency-loader"
      color="accent"
      diameter="100"
      i18n-aria-label
      mode="indeterminate"
    ></mat-spinner>
    <div #frequencyChart class="rds-variable-stats--frequency-chart" [class.hide]="loadingFrequencyChart"></div>
  </ng-container>

  <ng-container *ngIf="!variable?.summaryStatistics?.sets?.length && !variable?.frequencies?.sets?.length">
    <p class="mat-body-1" i18n>There are no summary statistics or frequencies for this variable.</p>
  </ng-container>
</section>
